import { useState, FormEvent } from "react";
import Navbar from "../../../components/layout/Navbar";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../components/Button";
import { toast } from "sonner";
import supabase from "../../../helper/supabaseClient";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("Please enter your email address.");
      return;
    }

    setIsLoading(true);
    try {
      const normalizedEmail = email.trim().toLowerCase();
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/password-reset`,
      });


      if (error) {
        console.error("Supabase error:", error);

        // Handle common Supabase errors
        if (error.message.includes("Invalid login credentials")) {
          toast.error("This email is not registered.");
        } else if (error.message.includes("rate limit")) {
          toast.error("Too many attempts. Please try again later.");
        } else {
          toast.error(error.message || "Failed to send reset email.");
        }
        return;
      }

      // Success
      localStorage.setItem("resetEmail", normalizedEmail);
      toast.success("Password reset email sent. Check your inbox.");
      navigate("/mail-reset");

    } catch (err) {
      console.error("Unexpected error:", err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="p-5 h-[81vh] sm:p-14 flex items-start md:items-center justify-center landing-bg bg-cover bg-no-repeat bg-center">
        <div className="w-full md:w-fit flex items-center justify-center flex-col bg-white">
          <div className="sm:p-10 rounded-2xl sm:border border-[#7E57C233] w-[100%] sm:w-[80%] md:w-fit flex items-center justify-between gap-20">
            <div className="flex flex-col gap-6 items-start justify-start w-[500px]">
              <h2 className="">Reset Password</h2>
              <form
                onSubmit={handleSubmit}
                className="flex flex-col items-start justify-center gap-10 w-full"
              >
                <div className="flex items-start justify-center flex-col gap-1.5 w-full">
                  <label htmlFor="email" className="text-[#666666CC]">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="johndoe@mail.com"
                    className="h-11 w-full border border-[#66666659] rounded-lg outline-0 px-3"
                    required
                  />
                </div>
                <Button
                  text={isLoading ? "Sending..." : "Reset Password"}
                  disabled={isLoading}
                />
              </form>
            </div>
            <img
              src="/assets/Jellosite-Logo-09.jpg"
              alt=""
              className="w-[250px] hidden md:block"
            />
          </div>
          <ul className="text-[#666666] md:w-full hidden sm:flex gap-3.5 sm:w-[80%] items-center justify-end mt-1">
            <Link to="/privacy_policy">
              <li>Privacy</li>
            </Link>
            <Link to="/terms_conditions">
              <li>Terms</li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
